import React, { memo } from "react";
import styled from "@emotion/styled";
import type { BlocksContent } from "@strapi/blocks-react-renderer";
import { BaseBlocksRenderer } from "@ui/components/common/base-blocks-renderer";

interface ArticleRendererProps {
	content: BlocksContent;
	className?: string;
}

const ContentWrapper = styled.div`
	flex-direction: column;
	gap: 24px;
`;

export const ArticleRenderer: React.FC<ArticleRendererProps> = memo(({ content, className }) => (
	<ContentWrapper className={className}>
		<BaseBlocksRenderer content={content} />
	</ContentWrapper>
));

ArticleRenderer.displayName = "ArticleRenderer";
